import { Component } from '@angular/core';

@Component({
  selector: 'app-news-pr2',
  templateUrl: './pr2.component.html',
  styleUrls: ['./pr2.component.scss']
})
export class NewsPR2Component {}
